import React from 'react';

function LoadingContainer({
  isLoading,
  hasData,
  initialText = 'Loading...',
  updatingText = 'Updating...',
  className = 'table-responsive',
  children,
}) {
  if (isLoading && !hasData) {
    return <div className="text-muted">{initialText}</div>;
  }

  return (
    <div className={`${className} app-loading-container`}>
      {isLoading ? <div className="app-loading-overlay">{updatingText}</div> : null}
      {children}
    </div>
  );
}

export default LoadingContainer;
